import { useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { useResultJSON } from './ResultJSON'; // Assuming this is your custom hook to fetch data
import { Survey } from 'survey-react-ui';
import { Model, surveyLocalization } from 'survey-core';
import "survey-core/survey.i18n";
import 'survey-core/defaultV2.min.css';

// Override individual translations in an existing locale:
const huLocale = surveyLocalization.locales["hu"];
huLocale.startSurveyText = "Indítás";
huLocale.pagePrevText = "Vissza";
huLocale.pageNextText = "Tovább";
huLocale.completeText = "Beküldés";
huLocale.completingSurvey = "Köszönjük a kitöltést!"

const postData = async (to_send: Object) => {
    try {
        const response = await fetch('https://aviatronic.hu/fipok/surveys/api/analyze', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // You can add other headers if needed
            },
            body: JSON.stringify(to_send), // Replace with your POST data
            mode: 'no-cors', // Set the mode to 'no-cors'
        });
        
        // When using 'no-cors' mode, you won't be able to access response data
        // or headers due to security restrictions.
        
        console.log('Request sent successfully, but response is blocked by CORS.');
        return response;
    } catch (error) {
        console.error('Error:', error);
        console.log('Error occurred while sending the request.');
        return;
    }
};

interface FIPOKSurveyProps {
    survey_id: string; // Define the survey_id prop
}

export const FIPOKSurvey: React.FC<FIPOKSurveyProps> = ({ survey_id }) => {
    // const navigate = useNavigate();
    // const bucketBaseURL = useResultJSONBucketBaseURL();
    const jsonData = useResultJSON(); // Assuming this hook fetches JSON data from the backend
    const auth0Obj = useAuth0();
    const { user } = auth0Obj;

    let survey = new Model(jsonData);
    survey.locale = "hu";

    const sendResults = (sender: Model) => {
        let send_body = {
            "meta": {
                "username": user?.nickname || user?.name || "fipok-com",
                "surveyId": survey_id,
                "locale": survey.locale,
                "save_id": ""
            },
            "answers": sender.data,
            "plainData": sender.getPlainData()
        };
        postData(send_body);

    };

    useEffect(() => {
        // Code for the effect
        if (jsonData == null) {
            return () => {
                // Perform cleanup tasks if needed
                survey.onComplete.remove(sendResults);
                console.log("jsonData was null!0");
            };
        }

        survey.onComplete.add(sendResults);

        // Cleanup function (optional)
        return () => {
            // Perform cleanup tasks if needed
            survey.onComplete.remove(sendResults);
        };
    }, [jsonData]); // Specify dependencies here

    if (jsonData == null) {
        console.log("jsonData was null!1");
        return <div></div>;
    }

    // Rest of your component code
    return <Survey model={survey} />;
};

export default FIPOKSurvey;